import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpErrorResponse, HttpEventType, HttpHeaders } from  '@angular/common/http';
import { map } from  'rxjs/operators';
import { URL_API, TOKEN_NAME } from './app.api';
@Injectable({
  providedIn: 'root'
})
export class UploadService {

  constructor(private httpClient: HttpClient) { }

  public getHeaderAuth(): HttpHeaders {
    let headers: HttpHeaders = new HttpHeaders({
      //'Content-Type':'application/json',
      'x-access-token':localStorage.getItem(TOKEN_NAME)
    });
    
    return headers;
  }

  public upload(data) {
    let uploadURL = `${URL_API}/api/upload-file-client`;
    let headers = this.getHeaderAuth();
    return this.httpClient.post<any>(uploadURL, data, {
      headers:headers,
      reportProgress: true,
      observe: 'events'
    }).pipe(map((event) => {

      switch (event.type) {

        case HttpEventType.UploadProgress:
          const progress = Math.round(100 * event.loaded / event.total);
          return { status: 'progress', message: progress };

        case HttpEventType.Response:
          return { status:'ok', body:event.body};
        default:
          return `Unhandled event: ${event.type}`;
      }
    })
    );
  }
}
